import React, { useContext, useState } from 'react'
import NavBar from '../components/ui/NavBar'

import { Switch, Route } from 'react-router-dom'
import DescargarScreen from '../components/descargas/DescargarScreen'
import { hostContext } from '../context/hostContext'
import PrivateRoute from './PrivateRoute'
import PanelDeControlScreen from '../components/descargas/PanelDeControlScreen'
import { AuthContext } from '../auth/AuthContext'
import MainPage from '../components/screens/MainPage'

const OrganizadorRoutes = () => {

    const { user } = useContext( AuthContext )

    const [selectedOrganizador, setSelectedOrganizador] = useState(null)
    const [ eventosAsistidos, setEventosAsistidos ] = useState( null );

    return (
        <>
            <NavBar />

            <hostContext.Provider value={{
                eventosAsistidos, setEventosAsistidos, selectedOrganizador, setSelectedOrganizador
            }}>
    
                <div className='roof-events-app'>
                    <Switch>
                        <PrivateRoute exact path='/organizador/dashboard' component= { PanelDeControlScreen } isAuthenticated={ user.logged } />
                        <Route exact path='/organizador/:id' component={ DescargarScreen } />
                        <Route path='/' component={MainPage} />
                    </Switch>
                </div>
            
            </hostContext.Provider>



        </>
    )
}

export default OrganizadorRoutes
